import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MibIconsModule, MibSpinnerComponent } from '@medinbox/angular';

@Component({
  selector: 'app-compatibility-card',
  imports: [MibSpinnerComponent, MibIconsModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './compatibility-card.component.html',
})
export class CompatibilityCardComponent {
  label = input<string | undefined>();
  compatibility = input<boolean | undefined>();
  description = input<string | undefined>();
  icon = input<'desktop' | 'browser' | 'video'>();
}
